export default {
  //baseUrl: window.baseUrl || process.env.NODE_ENV === 'production' ? 'http://47.101.207.23' : 'http://10.2.2.232:2240',
  baseUrl: window.baseUrl || "http://47.101.207.23",
  // baseUrl: window.baseUrl || 'http://localhost:8080',
  //reportUrl: window.reportUrl || 'http://www.comstarsoft.com/PrintService/report.aspx'
};
